import { Plus, X } from "lucide-react";

const today = () => new Date().toISOString().slice(0, 10);

export const CorrectionsFields = ({ value, onChange, inputCls }) => {
  const update = (i, key, v) => onChange(value.map((c, j) => (j === i ? { ...c, [key]: v } : c)));
  return (
    <div data-testid="admin-corrections-fields">
      <p className="block meta !text-[var(--ink-2)] mb-2">Corrections</p>
      <div className="grid gap-3">
        {value.map((c, i) => (
          <div key={i} className="grid gap-2 border border-[var(--rule)] p-3 relative" data-testid={`admin-correction-${i}`}>
            <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} className="absolute top-2 right-2 text-[var(--ink-3)] hover:text-[var(--accent)]" aria-label="Remove correction" data-testid={`admin-correction-remove-${i}`}>
              <X size={14} />
            </button>
            <input type="date" value={c.date} onChange={(e) => update(i, "date", e.target.value)} className={`${inputCls} w-40`} data-testid={`admin-correction-date-${i}`} />
            <textarea rows={3} value={c.text} onChange={(e) => update(i, "text", e.target.value)} placeholder="What was corrected, e.g. An earlier version misstated the year…" className={inputCls} data-testid={`admin-correction-text-${i}`} />
          </div>
        ))}
      </div>
      <button type="button" onClick={() => onChange([...value, { date: today(), text: "" }])} className="mt-3 inline-flex items-center gap-1.5 font-ui text-sm text-[var(--ink-2)] hover:text-[var(--accent)]" data-testid="admin-add-correction-button">
        <Plus size={14} /> Add a correction
      </button>
    </div>
  );
};
